import { render, staticRenderFns } from "./MesaUserProfile.vue?vue&type=template&id=c0b87822&scoped=true&"
import script from "./MesaUserProfile.vue?vue&type=script&lang=js&"
export * from "./MesaUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./MesaUserProfile.vue?vue&type=style&index=0&id=c0b87822&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b87822",
  null
  
)

export default component.exports